import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import "./SeeAllSubcategory.css";
import { wishlistUtils } from "../utils/userCartWishlistUtils";
import ProgressLoader from "../Loader/ProgressLoader";
import { FaArrowLeft, FaHeart, FaRegHeart } from "react-icons/fa";
import SkeletonLoader from "../SkeletonLoader/SkeletonLoader";

const SeeAllSubcategory = () => {
  const { subCategoryId } = useParams();
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOption, setSortOption] = useState("relevance");
  const [wishlistStatus, setWishlistStatus] = useState({});
  const [showLoginAlert, setShowLoginAlert] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { subCategoryName, categoryId } = location.state || {};
  useEffect(() => {
    if (!products.length) return;
    const wl = {};
    products.forEach((p) => {
      wl[p.id] = wishlistUtils.isInWishlist(p.id);
    });
    setWishlistStatus(wl);
  }, [products]);
  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(
          `https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_AllProducts_ProductsList?subCategoryId=${subCategoryId}`
        );
        setProducts(res.data);
        setFilteredProducts(res.data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [location.pathname, subCategoryId]);
  useEffect(() => {
    let updated = [...products];

    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      updated = updated.filter(
        (p) =>
          p.brandName.toLowerCase().includes(q) ||
          p.productName.toLowerCase().includes(q)
      );
    }

    if (sortOption === "lowToHigh") {
      updated.sort((a, b) => a.sellingPrice - b.sellingPrice);
    } else if (sortOption === "highToLow") {
      updated.sort((a, b) => b.sellingPrice - a.sellingPrice);
    }

    setFilteredProducts(updated);
  }, [searchQuery, sortOption, products]);
  const handleWishlistToggle = async (id) => {
    if (wishlistStatus[id]) {
      const ok = await wishlistUtils.removeFromWishlist(id);
      if (ok)
        setWishlistStatus((w) => ({ ...w, [id]: false }));
    } else {
      const ok = await wishlistUtils.addToWishlist(id);
      if (!ok) return setShowLoginAlert(true);
      setWishlistStatus((w) => ({ ...w, [id]: true }));
    }
  };
  const openProduct = (product) => {
    navigate(`/product/${product.id}`, {
      state: { product, productCategory: categoryId },
    });
  };
  if (loading)
    return (
      <>
      <div className="seeall-main-container">
          <div className="home-subcategory-section">
            <div className="subcategory-header">
              <div className="skeleton-shimmer skeleton-line medium" style={{ height: "20px" }}></div>
              <div className="skeleton-shimmer skeleton-line short" style={{ height: "20px" }}></div>
            </div>
              <div className="seeall-products-grid">
                {Array(10).fill(0).map((_, idx) => (
                  <SkeletonLoader key={idx} />
                ))}
              </div>
          </div>
      </div>
      </>
    );
  return (
    <>
      <div className="seeall-main-container">
        {/* Header row */}
        <div className="seeall-header">
          <div className="seeall-header-left">
            <div className="seeall-backarrow" onClick={() => navigate(-1)}>
              <FaArrowLeft size={25} color="#920504" />
            </div>

            <h2 className="seeall-page-title m-0" style={{ color: "#920504" }}>
              {subCategoryName || "Products"}
            </h2>
          </div>

          <div className="seeall-sort-container">
            <select
              className="form-select"
              value={sortOption}
              onChange={(e) => setSortOption(e.target.value)}
            >
              <option value="relevance">Relevance</option>
              <option value="lowToHigh">Low to High</option>
              <option value="highToLow">High to Low</option>
            </select>
          </div>
        </div>


        {/* Product Grid */}
        <div className="seeall-products-grid">
          {filteredProducts.length ? (
            filteredProducts.map((p) => (
              <div key={p.id} className="seeall-product-card">
                <div
                  className="seeall-product-image-container"
                  onClick={() => openProduct(p)}
                >
                  <img
                    src={
                      p.productImage
                        ? `https://api.dremerz.net/uploads/${p.productImage}`
                        : "/default-product.jpg"
                    }
                    loading="lazy"
                    alt={p.brandName}
                    className="seeall-product-image"
                  />
                  {p.tags && <span className="seeall-product-tag">{p.tags}</span>}
                </div>

                <div className="seeall-product-info">
                  <h3
                    className="seeall-product-brandname m-0"
                    onClick={() => openProduct(p)}
                  >
                    {p.brandName}
                  </h3>

                  <p className="seeall-product-name m-0">{p.productName}</p>

                  <div className="seeall-product-price m-0">
                    <span className="seeall-current-price">₹{p.sellingPrice}</span>

                    {p.originalPrice && (
                      <>
                        <span className="seeall-original-price">
                          ₹{p.originalPrice}
                        </span>
                        <span className="seeall-offer">
                          (
                          {Math.round(
                            ((p.originalPrice - p.sellingPrice) /
                              p.originalPrice) *
                              100
                          )}
                          % OFF)
                        </span>
                      </>
                    )}
                  </div>

                  <div className="seeall-product-actions">
                    <button
                      className={`seeall-wishlist-btn ${
                        wishlistStatus[p.id] ? "seeall-in-wishlist" : ""
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleWishlistToggle(p.id);
                      }}
                    >
                      {wishlistStatus[p.id] ? <FaHeart /> : <FaRegHeart />}
                      {wishlistStatus[p.id] ? " Wishlisted" : " Wishlist"}
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="seeall-no-products">
              <p>No products found matching your search.</p>
            </div>
          )}
        </div>

        {/* Login Alert Modal */}
        {showLoginAlert && (
          <div className="seeall-modal-overlay">
            <div className="seeall-modal-content">
              <h3>Login Required</h3>
              <p>Please login to add items to your wishlist.</p>

              <div className="seeall-modal-actions">
                <button
                  className="seeall-btn-cancel"
                  onClick={() => setShowLoginAlert(false)}
                >
                  Cancel
                </button>
                <button
                  className="seeall-btn-login"
                  onClick={() => navigate("/login")}
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SeeAllSubcategory;
